import React from 'react';
import { ArrowLeft, Linkedin } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Card } from './ui/card';

const WhoWeAre = () => {
  const navigate = useNavigate();

  const founders = [
    {
      name: 'Dr. Jeff Leinaweaver',
      image: 'https://customer-assets.emergentagent.com/job_career-leisure-hub/artifacts/l4wo8het_jeff.jpeg',
      title: 'American, Co-Founder',
      linkedin: 'https://www.linkedin.com/in/jeffleinaweaver/',
      bio: 'Jeff, American, co-founder, is a senior human resources leader and certified sustainability professional with a unique track record of helping some top organizations address challenging talent acquisition, workforce planning, and leadership development and sustainability/ESG needs. He works at the University of Washington as a faculty member teaching graduate-level HR courses and consults with organizations on strategic workforce planning and leadership development.',
      fullBio: 'Jeff has over 25 years of experience in human resources leadership roles across various industries. His expertise includes talent management, organizational development, and creating sustainable business practices. He holds a Ph.D. in Organizational Behavior and is a Global Professional in Human Resources (GPHR). Jeff is passionate about helping individuals and organizations reach their full potential through innovative career development tools and resources.'
    },
    {
      name: 'Rogier Rijnja',
      image: 'https://customer-assets.emergentagent.com/job_career-leisure-hub/artifacts/d8g10j5f_Rogier%20Rijnja%20Green%20shirt.jpg',
      title: 'Dutch, Co-Founder',
      linkedin: 'https://www.linkedin.com/in/rijnja/',
      bio: 'Rogier, Dutch, co-founder, has an extensive background in executive human resources roles with American and European multinational companies. (Apple, Nike, Amazon, Reckitt Benckiser, Sara Lee/JDE, Danone/Numico) and as a non-exec board member of Nebius Group, a Nasdaq listed AI Infrastructure company. Rogier did Law School. He is an executive coach and entrepreneur.',
      fullBio: 'With a law degree and decades of experience at some of the world\'s most respected companies, Rogier brings a unique perspective on career development and organizational excellence. His international experience spans continents and cultures, making him uniquely positioned to understand the diverse needs of modern professionals. As an executive coach and board member, he continues to shape the future of work and career development.'
    }
  ];

  return (
    <div className="who-we-are-container">
      {/* Header */}
      <header className="who-we-are-header">
        <Button 
          variant="ghost" 
          className="back-button"
          onClick={() => navigate('/')}
        >
          <ArrowLeft className="back-icon" />
          Back to Home
        </Button>
        <div className="header-content">
          <div className="logo-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_career-leisure-hub/artifacts/wugpgoix_Findmino%20Logo%20purple.png" 
              alt="FindMino Logo" 
              className="site-logo"
            />
            <h1 className="site-title">Likemymind</h1>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="who-we-are-main">
        {/* Who Are We Section */}
        <section className="ownership-section">
          <Card className="ownership-card">
            <h2 className="section-title">Who Are We?</h2>
            <p className="ownership-text">
              <strong>Likemymind's initiatives are owned by Likemymind Media B.V.</strong>, a Dutch privately owned legal entity, which again owns <strong>Likemymind America Inc</strong>, that's running The Career Cube and Findmino.com, and <strong>Likemymind Netherlands B.V</strong> that's hosting Findmino.nl
            </p>
          </Card>
        </section>

        {/* About Us - Founders Section */}
        <section className="founders-section">
          <h2 className="section-title-main">About Us</h2>
          <div className="founders-grid">
            {founders.map((founder, index) => (
              <Card key={index} className="founder-card">
                <div className="founder-image-wrapper">
                  <img 
                    src={founder.image} 
                    alt={founder.name}
                    className="founder-image"
                  />
                </div>
                <h3 className="founder-name">{founder.name}</h3>
                <p className="founder-title">{founder.title}</p>
                <a 
                  href={founder.linkedin} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="linkedin-link"
                >
                  <Linkedin className="linkedin-icon" />
                  View LinkedIn Profile
                </a>
                <p className="founder-bio">{founder.bio}</p>
                <details className="founder-details">
                  <summary className="show-more-btn">+ Show More</summary>
                  <p className="founder-full-bio">{founder.fullBio}</p>
                </details>
              </Card>
            ))}
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="likemymind-footer">
        <p className="footer-text">© 2026 likemymind • Connecting platforms that inspire growth and discovery</p>
      </footer>
    </div>
  );
};

export default WhoWeAre;